function niceNum(value) {
  var re = '';
  if (!value && value != 0) {return re;}
  value = parseFloat(value);
  value = Math.floor(value * 100 + 0.5) / 100;
  value = value.toString();
  var tmp = value.split('.');
  var dr = (tmp[1]) ? tmp[1] : '00';
  if (dr.length == 1) {
    dr = dr + '0';
  }
  dr = dr.substr(0, 2);
  var dl = tmp[0].split('');
  dl = dl.reverse();
  dl.forEach(function(item, index) {
    re = item + re;
    if ((index + 1) % 3 == 0 && (index + 1) < dl.length) {
      re = ',' + re;
    }
  });
  re += '.' + dr;
  return re;
}

export default niceNum;



// WEBPACK FOOTER //
// ./node_modules/bjxy-common/filters/niceNum.js